// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationRiskProtectionPath = 'M53.642 3.93L70.945.62l3.056 16.366-6.882 1.285-.963-5.16-9.663 12.862C76.007 28.853 91 44.505 91 63.498v3.5H53.29v21.174c-.008 6.534-5.306 11.826-11.84 11.826a11.83 11.83 0 01-8.115-3.222l-.25-.243-2.06-2.06 4.95-4.95 2.06 2.06a4.83 4.83 0 003.415 1.415 4.84 4.84 0 004.835-4.615l.005-.215v-21.17H9v-3.5C9 45.072 23.112 29.79 41.773 26.264L33.63 18.12l4.242-4.243 11.537 11.536 11.886-15.82-6.336 1.213-1.316-6.875zm30.143 56.068H68.428c-.415-10.097-2.623-19.126-6.136-25.412 11.416 4.04 19.82 13.539 21.428 24.925l.065.487zm-67.566-.03c1.446-11.59 9.92-21.289 21.49-25.382-3.514 6.286-5.722 15.315-6.137 25.412H16.214l.005-.03zm22.366-.05l-.004.08h22.837l-.028-.56c-.825-15.183-6.163-26.687-11.223-26.936L50 32.498c-5.163 0-10.67 11.833-11.415 27.42z';
var IllustrationRiskProtection = baseIllustration('IllustrationRiskProtection', {
  getPath: () => IllustrationRiskProtectionPath
}, 'ColoredIllustrationRiskProtection');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationRiskProtection;
//# sourceMappingURL=index.js.map